{
  "pt_BR": "hoteis",
  "cs_CZ": "hotely",
  "da_DK": "hoteller",
  "de_DE": "hotels",
  "en_GB": "hotels",
  "es_ES": "hoteles",
  "fi_FI": "hotellit",
  "fr_FR": "hotels",
  "it_IT": "hotel",
  "ja_JP": "hoteru",
  "ko_KR": "hoterdeur",
  "nl_NL": "hotels",
  "nb_NO": "hotels",
  "pl_PL": "hotele",
  "pt_PT": "hoteis",
  "ru_RU": "oteli",
  "sv_SE": "hotell",
  "tr_TR": "oteller",
  "zh_CN": "jiudian"
}
